import { useEffect } from "react";
import type { MetaDataPropertyType } from "types/metaDataPropertyTypes";
import type { PropertyCriteria } from "types/qbank/propertyCriteria";
import { SearchOperator } from "types/qbank/searchOperator";
import * as UI from "components/ui";

export default function Checkbox(props: {
  propertyType: MetaDataPropertyType;
  setCriteria: (propertyCriteria: PropertyCriteria) => void;
  setChecked: (checked: boolean) => void;
  checked: boolean;
}) {
  useEffect(() => {
   // if (props.checked) {
      props.setCriteria({
        id: props.propertyType.id,
        systemName: props.propertyType.systemname,
        operator: SearchOperator.EQUAL,
        value: props.checked ? true : undefined, //Don't set "false", absence of "true" value equals false
        label: props.propertyType.name,
      });
   // }
    // eslint-disable-next-line
  }, [props.checked]);

  return (
    <div className="field" data-testid="checkbox">
      <label className="label">{props.propertyType.name}</label>

      <div className="control">
        <UI.Checkbox
          value={1}
          checked={props.checked}
          onChange={(e) => props.setChecked(e.target.checked)}
        />
      </div>
    </div>
  );
}
